import React, { useEffect } from "react";
import { concentratorType } from "../../../../../../shared_lsi_sg/concentratorData";
import ConcentratorSelectors from "./templateConcentratorCustom/ConcentratorSelectors";
import ConcentratorCorePortable from "./templateConcentratorCustom/core/ConcentratorCorePortable";
import ConcentratorCoreTransportable from "./templateConcentratorCustom/core/ConcentratorCoreTransportable";
import ConcentratorCoreOtherInfo from "./templateConcentratorCustom/core/ConcentratorCoreOtherInfo";

export function TemplateConcentratorPortable({ dataForm, changeValue, errors, setData, isSubmit }) {
  const legacyValidUntil =
    dataForm?.["fixed.validUntil"]
    || dataForm?.["portable.validUntil"]
    || dataForm?.["transportable.validUntil"]
    || dataForm?.fixed?.validUntil
    || dataForm?.portable?.validUntil
    || dataForm?.transportable?.validUntil;

  const changeValueHandler = (data) => {
    if (data.name === "concentratorType") {
      const newType = data.value;
      // Preserve shared fields (pathology, otherPathologies, validUntil)
      // Only clear fields specific to the type being switched away from
      const newData = { ...dataForm, concentratorType: newType };
      if (newType === concentratorType.portable) {
        Object.keys(newData).forEach((key) => {
          if (key.startsWith("transportable.")) {
            delete newData[key];
          }
        });
      } else if (newType === concentratorType.transportable) {
        Object.keys(newData).forEach((key) => {
          if (key.startsWith("portable.")) {
            delete newData[key];
          }
        });
      }
      setData(newData);
      return;
    }
    changeValue && changeValue(data);
  };

  useEffect(() => {
    if (!dataForm?.validUntil && legacyValidUntil) {
      changeValue && changeValue({ name: "validUntil", value: legacyValidUntil });
    }
  }, [changeValue, dataForm?.validUntil, legacyValidUntil]);

  const selectedType = dataForm?.concentratorType;

  return (
    <>
      <ConcentratorSelectors
        dataForm={dataForm}
        changeValue={changeValueHandler}
        errors={errors}
        isSubmit={isSubmit}
        templateType="portable"
      />

      {selectedType === concentratorType.portable && (
        <>
          <ConcentratorCorePortable
            isSubmit={isSubmit}
            errors={errors}
            changeValue={changeValue}
            dataForm={dataForm}
            setData={setData}
            prescriptionTitle="Portatile"
          />
          <ConcentratorCoreOtherInfo
            isSubmit={isSubmit}
            errors={errors}
            changeValue={changeValue}
            dataForm={dataForm}
            setData={setData}
          />
        </>
      )}

      {selectedType === concentratorType.transportable && (
        <>
          <ConcentratorCoreTransportable
            isSubmit={isSubmit}
            errors={errors}
            changeValue={changeValue}
            dataForm={dataForm}
            setData={setData}
            prescriptionTitle="Trasportabile"
          />
          <ConcentratorCoreOtherInfo
            isSubmit={isSubmit}
            errors={errors}
            changeValue={changeValue}
            dataForm={dataForm}
            setData={setData}
          />
        </>
      )}
    </>
  );
}
